import { gql } from '__generated__';

export default gql(`
  mutation EditPurchaseFromBackend($input: EditPurchaseInput!) {
    editPurchase(input: $input) {
      ...EditPurchaseAttributes
    }
  }
`);
